/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnlink2Inputs */

const en_partnerscolumnlink2 = /** @type {(inputs: Partnerscolumnlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner link`)
};

const de_partnerscolumnlink2 = /** @type {(inputs: Partnerscolumnlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerlink`)
};

/**
* | output |
* | --- |
* | "Partner link" |
*
* @param {Partnerscolumnlink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnlink2 = /** @type {((inputs?: Partnerscolumnlink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnlink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnlink2(inputs)
	return de_partnerscolumnlink2(inputs)
});
export { partnerscolumnlink2 as "partnersColumnLink" }